import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-file',
  templateUrl: './icon-file.component.svg',
  styleUrls: ['./icon-file.component.css'],
})
export class IconFileComponent {}
